import API_BASE_URL from './urlHelper';
import { fetchWithAuth } from './authToken';

export async function getCuotasPendientes(fecha = null) {
  const url = new URL(`${API_BASE_URL}/api/asesor/cuotas-pendientes`);

  if (fecha) {
    url.searchParams.append('fecha', fecha);
  }

  const res = await fetchWithAuth(url.toString(), {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (!res.ok) {
    throw new Error(await obtenerMensajeError(res));
  }

  const data = await res.json();

  if (!data.success) {
    throw new Error(data.message || 'Error al obtener cuotas pendientes');
  }

  return data;
}

async function obtenerMensajeError(response) {
  const mensajesError = {
    401: 'Sesión expirada. Por favor, inicie sesión nuevamente.',
    403: 'No tiene permisos para acceder a esta información.',
  };

  if (mensajesError[response.status]) {
    return mensajesError[response.status];
  }

  const body = await response.text().catch(() => '');
  return `Error ${response.status}: ${body || 'Error al cargar cuotas pendientes'}`;
}

export function getDescripcionPeriodo(meta = {}) {
  const descripciones = {
    lunes_proximo: {
      texto: 'el lunes',
      textoCompleto: 'Mostrando cuotas del lunes próximo',
    },
    dia_siguiente: {
      texto: 'mañana',
      textoCompleto: 'Mostrando cuotas de mañana',
    },
    hoy: {
      texto: 'hoy',
      textoCompleto: 'Cuotas que vencen hoy',
    },
    manual: {
      texto: 'la fecha seleccionada',
      textoCompleto: 'Cuotas para la fecha seleccionada',
    },
  };

  if (meta.incluye_fecha_anterior) {
    if (meta.tipo_periodo === 'dia_siguiente') {
      return {
        texto: 'hoy y mañana',
        textoCompleto: 'Mostrando cuotas de hoy y mañana',
      };
    }

    if (meta.tipo_periodo === 'lunes_proximo') {
      return {
        texto: 'hoy y el lunes',
        textoCompleto: 'Mostrando cuotas de hoy y el lunes',
      };
    }
  }

  return descripciones[meta.tipo_periodo] || descripciones.hoy;
}
